import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Languages } from 'lucide-react';

export const LanguageSwitcher = ({ variant = 'default', className = '' }) => {
  const { language, toggleLanguage, isAmharic } = useLanguage();

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={toggleLanguage}
      className={`gap-2 ${className}`}
      data-testid="language-switcher"
    >
      <Languages className="w-4 h-4" />
      <span>{isAmharic ? 'English' : 'አማርኛ'}</span>
    </Button>
  );
};